module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-site-768x591.0f894dc7.jpg";